module.exports = __webpack_public_path__ + "img/img8.d90150a7.svg";